var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{staticClass:"faq-question",attrs:{"id":_vm.faq.id}},[_c('h3',{staticClass:"question",domProps:{"innerHTML":_vm._s(_vm.faq.question)}}),_c('p',{staticClass:"answer",domProps:{"innerHTML":_vm._s(_vm.faq.answer)}})])}
var staticRenderFns = []

export { render, staticRenderFns }